module.exports = __webpack_public_path__ + "img/font1.9862409b.png";